type PieLabelProps = {
  labelData: {
    x: number;
    y: number;
    cx: number;
    cy: number;
    value?: number;
    percent?: number;
  };
};

const PieLabel = ({ labelData }: PieLabelProps) => {
  return (
    <text
      aria-label="pie-chart-label"
      className="fill-text-primary"
      x={labelData.x}
      y={labelData.y}
      textAnchor={labelData.x > labelData.cx ? 'start' : 'end'}
      dominantBaseline="central"
      fontSize={12}
    >
      {Number((labelData?.percent ?? 0) * 100).toFixed(2)}%
    </text>
  );
};

export default PieLabel;
